module.exports = __webpack_public_path__ + "static/media/(V)_MG_6028_-_Cia_Termal_Beachewear_-_Moda_Feminina_Infantil.cef9560f.jpg";